import * as React from 'react';
import { TestStatus } from '@snapi/types';
import AnalyzingImg from './images/analyzing.png';
import ReadyImg from './images/ready.png';
import ReceivedImg from './images/received.png';
import PendingImg from './images/pending.png';
import Image, { ImageProps, StaticImageData } from 'next/image';

const TestStatusToIcon: {
  [key in TestStatus]: StaticImageData;
} = {
  [TestStatus.pending]: PendingImg,
  [TestStatus.analyzing]: AnalyzingImg,
  [TestStatus.ready]: ReadyImg,
  [TestStatus.received]: ReceivedImg,
};

export type TestStatusIconProps = {
  status: TestStatus;
  height: number;
} & Omit<ImageProps, 'src'>;

export const TestStatusIcon: React.FC<TestStatusIconProps> = ({
  status,
  height,
}) => (
  <div
    style={{
      width:
        (TestStatusToIcon[status].width / TestStatusToIcon[status].height) *
        height,
    }}
  >
    <Image {...TestStatusToIcon[status]} layout="responsive" alt={status} />
  </div>
);
